import { render, staticRenderFns } from "./ButtonTwitterLogin.vue?vue&type=template&id=0ceb2a6e&"
import script from "./ButtonTwitterLogin.vue?vue&type=script&lang=ts&"
export * from "./ButtonTwitterLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports